import { useGetPopularMeals } from "@/hooks/requests/meal/use-get-popular-meals";
import { memo } from "react";
import { HomeFeedMealsList } from "../home-feed-meals-list";

export const PopularOnPlanList = memo(function PopularOnPlanList() {
  const { popularMeals, isLoading } = useGetPopularMeals();

  return (
    <HomeFeedMealsList
      title="Popular on plan"
      meals={popularMeals}
      isLoading={isLoading}
      emptyStateText="No popular meals available right now."
    />
  );
});
